const Review = [
    {
        id: 1,
        name: 'Green Rabbit CEO',
        quote: 'One thing that I am sure of about you guys is that you show more energy than my previous shillers. Your team is the best team of shillers that I have ever worked with in crypto. Thumbs up guys! '
    },
    {
        id: 2,
        name: 'EVSOL',
        quote: 'Your team of designers, developers and shillers are doing a great job and we attribute the success of our presale to the dedication and expertise of your team. I will gladly recommend your team to my associates for future projects.'
    },
    {
        id: 3,
        name: 'MyTeamCoin',
        quote: 'Your team is the best! Your moderators are always active on our official telegram group and your shillers are keeping twitter agog with our project. I will love to work with you on a long term and refer you for more projects.'
    } 
]

export default Review;